import React from 'react';
import Loader from 'components/Loader';

import { Carousel, CarouselTile, GradientImage, Repeater, TextRow } from 'components/Skeleton';
import Divider from '../Divider';

import Style from './FoxContentDensitySkeleton.module.scss';

const FoxContentDensitySkeleton = () => (
  <div className={Style.wrapper}>
    <div className={Style.loader}>
      <Loader />
    </div>
    <div className={Style.background}>
      <div className={Style.bottomFade} />
    </div>
    <div className={Style.hero}>
      <div className={Style.content}>
        <div className={Style.info}>
          <TextRow type="Regular" className={Style.textRow1} />
          <TextRow type="Regular" className={Style.textRow2} />
          <TextRow type="Regular" className={Style.textRow3} />
          <TextRow type="Regular" className={Style.textRow4} />
          <TextRow type="Regular" className={Style.textRow5} />
          <TextRow type="Rounded" className={Style.textRow6} />
        </div>
      </div>
    </div>
    <Divider />
    <Repeater times={2}>
      <>
        <div className={Style.collection}>
          <TextRow type="Regular" className={Style.textRow1} />
          <Carousel className={Style.carousel}>
            <Repeater times={4}>
              <CarouselTile className={Style.carouselTile}>
                <GradientImage type="Wide" className={Style.image1} />
                <TextRow type="Regular" className={Style.textRow1} />
                <TextRow type="Regular" className={Style.textRow2} />
              </CarouselTile>
            </Repeater>
          </Carousel>
        </div>
        <Divider />
      </>
    </Repeater>

    <div className={Style.cast}>
      <Carousel className={Style.carousel}>
        <Repeater times={6}>
          <CarouselTile className={Style.carouselTile}>
            <GradientImage type="Rounded" className={Style.image1} />
            <TextRow type="Center" className={Style.textRow1} />
          </CarouselTile>
        </Repeater>
      </Carousel>
    </div>
    <Divider />

    <div className={Style.poster}>
      <TextRow type="Regular" className={Style.textRow1} />
      <Carousel className={Style.carousel}>
        <Repeater times={5}>
          <CarouselTile className={Style.carouselTile}>
            <GradientImage type="Poster" className={Style.image1} />
          </CarouselTile>
        </Repeater>
      </Carousel>
    </div>
    <Divider />

    <div className={Style.about}>
      <TextRow type="Regular" className={Style.textRow1} />
      <div className={Style.content}>
        <div className={Style.aboutText}>
          <Repeater times={4}>
            <TextRow type="Regular" className={Style.textRow2} />
          </Repeater>
          <TextRow type="Regular" className={Style.textRow3} />
        </div>
        <div className={Style.aboutIcons}>
          <Repeater times={4}>
            <div className={Style.icon} />
          </Repeater>
        </div>
      </div>
    </div>
    <Divider />

    <div className={Style.links}>
      <TextRow type="Regular" className={Style.textRow1} />
      <div className={Style.content}>
        <TextRow type="Rounded" className={Style.textRow1} />
        <TextRow type="Rounded" className={Style.textRow2} />
        <TextRow type="Rounded" className={Style.textRow3} />
        <TextRow type="Rounded" className={Style.textRow4} />
        <TextRow type="Rounded" className={Style.textRow5} />
      </div>
      <div className={Style.content}>
        <TextRow type="Rounded" className={Style.textRow6} />
        <TextRow type="Rounded" className={Style.textRow7} />
        <TextRow type="Rounded" className={Style.textRow8} />
        <TextRow type="Rounded" className={Style.textRow9} />
      </div>
    </div>
    <div className={Style.block}>
      <TextRow type="Regular" className={Style.textRow1} />
    </div>
  </div>
);

export default FoxContentDensitySkeleton;
